import { render, staticRenderFns } from "./productPlanList.vue?vue&type=template&id=3b6aedc5&scoped=true&"
import script from "./productPlanList.vue?vue&type=script&lang=js&"
export * from "./productPlanList.vue?vue&type=script&lang=js&"
import style0 from "./productPlanList.vue?vue&type=style&index=0&id=3b6aedc5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6aedc5",
  null
  
)

export default component.exports